import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/digital-media/layout';
import { Container, makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '130px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '96px',
    },
    borderBottom: '1px solid #e1e1e1',
  },
  slotholder: {
    backgroundImage: `url('/img/digital-media/t_enterprise.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    width: '100%',
    height: '120px',
    [theme.breakpoints.up('md')]: {
      height: '200px',
    },
  },
  caption: {
    textAlign: 'center',
    color: 'white',
    fontSize: '30px',
    [theme.breakpoints.up('md')]: {
      fontSize: '48px',
      paddingTop: '65px',
      padingLeft: '90px',
    },
    paddingTop: '50px',
    paddingLeft: '80px',
  },
  captionEng: {
    textAlign: 'center',
    color: 'white',
    fontSize: '15px',
    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
      paddingLeft: '360px',
    },
    paddingLeft: '240px',
    fontWeight: '200',
  },
  section1: {
    backgroundImage: `url('/img/digital-media/1231.png')`,
    backgroundRepeat: 'repeat-x',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'top center',
    textAlign: 'center',
    fontsize: '16px',
    color: '#727272',
    paddingTop: '50px',
    paddingBottom: '50px',
  },
  section2: {
    paddingTop: '70px',
    marginLeft: '20px',
    marginRight: '20px',
  },
  hr: {
    lineHeight: '25px',
    borderColor: '#dddddd',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    position: 'relative',
    margintTop: '15px',
    marginBottom: '30px',
  },
  contents: {
    color: '#666666',
    fontSize: '13px',
    lineHeight: '1.65em',
  },
  icon: {
    paddingTop: '30px',
  },
}));

export default function MamSolution() {
  const classes = useStyles();

  return (
    <Layout>
      <Helmet>
        <title>MALGN | KeyFlow Enterprise</title>
      </Helmet>
      <div className={classes.wrapper}>
        <div className={classes.slotholder}>
          <div className={classes.caption}>KeyFlow Enterprise</div>
          <div className={classes.captionEng}>MAM Solution</div>
        </div>
        <div className={classes.section1}>
          <Container maxWidth="md">
            <p>
              전문적인 컨텐츠 관리를 염두에 두고 있다면 KeyFlow Enterprise
              시스템으로 시작하십시오.
            </p>
            <p>
              KeyFlow Enterprise는 모듈화된 아키텍처로 다양한 플랫폼과
              워크플로우에 유연하게 대응할 수 있습니다.
            </p>
            <p>
              외부의 다양한 인제스트, 트랜스코딩, 아카이빙, 디렉토리 관리
              솔루션들과 연계가 가능하며,
            </p>
            <p>
              내장된 강력한 기능과 사용자 친화적인 UX로 업무 효율을 극대화시켜
              드립니다.
            </p>
          </Container>
        </div>
      </div>
      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>OVERVIEW </h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <h3>멀티 플랫폼</h3>
                <span className={classes.contents}>
                  사용자는 동일한 기능을 원하는 플랫폼에서 즐길 수 있습니다.
                  KeyFlow Enterprise는 Mac 및 Windows 등 해당 플랫폼의 특성에
                  맞게 디자인 되었으며, 전체적인 기능을 동일한 환경으로
                  제공합니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>메타데이터 디자인</h3>
                <span className={classes.contents}>
                  MAM(Media Asset Management) 시스템 구성의 시작인 메타데이터
                  디자인 부분은 기본적으로 제공하는 메타데이터 외 사용자
                  시스템에 적합할 수 있도록 사용자 참여 가능한 구조를
                  제공합니다. 기본적으로 제공하는 메타데이터는 IPTC 같은 표준
                  메타데이터를 근거로 작성되었으며, 사용자가 원하는 메타데이터는
                  KeyFlow Enterprise에서 제공하는 메타데이터 제너레이터를 통해
                  손쉽게 생성 및 검증, 새로운 메타데이터를 적용할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>사용자 및 그룹 관리</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise의 계정들은 NLE 사용자나 기타 컴포넌트
                  사용자들을 위해 대부분 Active Directory 또는 Open Directory
                  같은 업계 표준의 디렉토리 서비스를 준수합니다. 디렉토리
                  서비스는 사용자와 네트워크 리소스 정보를 일원화하기 위해
                  사용하는 중요한 서비스입니다. KeyFlow Enterprise는 Active
                  Directory 또는 Open Directory 서비스 연동 기능을 통해 손쉽게
                  통합 계정 관리를 할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>컴포넌트 관리</h3>
                <span className={classes.contents}>
                  하나의 MAM 시스템은 단순히 서버만으로 이루어지지 않습니다.
                  다양한 미디어 처리를 위한 여러 가지 소프트웨어 및 하드웨어를
                  조합해서 자동화 및 수동화를 연출할 수 있어야지만 원할한
                  워크플로우를 구성하고, 이를 관리할 수 있습니다. KeyFlow
                  Enterprise 서버는 이러한 환경을 매우 편리한 구조로 제공하고
                  있습니다. KeyFlow Manager를 통해 시스템을 구성하는 여러 가지
                  컴포넌트 소프트웨어 뿐만 아니라 SDK를 통해 연동하는 여러 가지
                  서드파티 제품들을 하나의 장소에서 편리하게 관리할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>서버 이중화</h3>
                <span className={classes.contents}>
                  기존 하드웨어 방식의 이중화 환경이 가진 단점을 보완하고자
                  KeyFlow Enterprise 서버는 소프트웨어 방식을 통해 비용 절감은
                  물론 안정적인 서버 이중화 환경을 제공합니다. KeyFlow
                  Enterprise 서버의 이중화 환경을 먼저 경험해보신 후
                  하드웨어적인 이중화 환경을 고려하셔도 늦지 않습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>스토리지 모니터링</h3>
                <span className={classes.contents}>
                  네트워크 기반의 제작 시스템을 운영하다보면 넘쳐나는 애셋으로
                  인해 스토리지 용량이 부족해지는 문제가 종종 발생합니다.
                  KeyFlow Enterprise는 이러한 근본적인 문제를 막기 위한 기본적인
                  안전 시스템을 제공합니다. KeyFlow Enterprise 서버의 스토리지
                  모니터링 기능은 SAN 및 NAS 환경에서 원활하게 동작하고,
                  인제스트 같은 애셋의 생성 과정에서부터 매우 정밀하게 결합되어
                  동작합니다. 관리자는 문제의 발생 여부를 신속하게 판단할 수
                  있으며, 더욱더 안정된 시스템으로 만들어 나갈 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>상태 기록</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise는 서버가 동작하는 과정에서 발생하는
                  핵심적인 모든 과정들을 기록합니다. 기록되는 정보를 통해
                  사용자는 어떠한 일들이 어떻게 일어나고 있는지를 한눈에 파악할
                  수 있으며 이를 근거로 다양한 통계 자료로 사용할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>Open API를 통한 시스템 확장성</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise 서버는 업계 표준 기술들을 기반으로 설계 및
                  구현 되었습니다. 하나의 작은 XML도 어떠한 플랫폼에서도 동작할
                  수 있도록 되어 있습니다. KeyFlow Enterprise 서버에는 Open API
                  서버가 내장되어 있고, 이를 통해 사용자 요구에 따른 기능 확장을
                  손쉽게 할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>다양한 NLE 지원</h3>
                <span className={classes.contents}>
                  현재 방송 제작 NLE의 대다수를 차지하고 있는 Final Cut Pro
                  7부터 새버전의 Final Cut Pro X, Adobe Premiere Pro, EDIUS 등
                  어떠한 프로그램을 사용하더라도 KeyFlow Enterprise와 완벽하게
                  호환됩니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>SDK</h3>
                <span className={classes.contents}>
                  KeyFlow 시스템은 Mac, Windows, Web Client 모두를 지원합니다.
                  네이티브 SDK를 사용하면 Mac 또는 Windows 클라이언트를 손쉽게
                  개발할 수 있으며 함께 지원되는 Open API를 사용하면 Web Client
                  및 모바일 워크플로우를 위한 애플리케이션을 손쉽게 개발할 수
                  있습니다.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>KEY FEATURES </h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <h3>프로페셔널 포맷 핸들러</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise는 여러 종류의 방송용 비디오 코덱 지원은
                  기본이며 5,000여개 이상 디지털 카메라 이미지 포맷 및 RAW
                  포맷을 지원하며 TGA, TIFF, PSD, PDF같은 한차원 높은 포맷
                  지원으로 보다 풍부한 애셋들을 관리할 수 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>합리적이면서 강력한 시스템 구성</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise는 서버 및 다양한 기능을 제공하는 컴포넌트
                  서버, 플랫폼 독립적인 우수한 사용자 클라이언트 환경을
                  제공합니다. 64비트 구조의 서버, 다양한 방송용 미디어 처리를
                  위한 미디어 변환 시스템, 워크플로우, 사용자 관리 시스템, 서버
                  이중화 등 강력한 기능이 합리적으로 구성되어 있습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>Editing Playback</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise의 Editing Playback 기능은 단순히 미디어의
                  재생 뿐만 아니라 아카이브 또는 프리뷰 노트같은 고급 기능들을
                  드래그만으로 쉽게 설정하고 활용할 수 있는 환경을 제공합니다.
                  Editing Playback 은 말 그대로 편집 환경과 재생 기능을 함께
                  제공하는 차세대 기능입니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>미디어 그룹</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise에서 애셋 관리는 인제스트 시점부터 단일 애셋
                  및 그룹 형태로 생성해서 관리할 수 있습니다. 그룹 내부에는
                  비디오, 오디오, 이미지 등 다양한 미디어를 포함할 수 있으며,
                  하나의 그룹은 하나의 프로젝트 스타일로 활용이 가능합니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>아카이브 전문가</h3>
                <span className={classes.contents}>
                  KeyFlow Enterprise는 여러 가지 써드파티 아카이브 제품들과
                  완벽한 호흡을 자랑합니다. DIVA 및 기타 유수 업체들의 아카이브
                  솔루션과 쉽게 통합할 수 있는 환경을 기본적으로 제공하고
                  사용자는 그 자리에서 아카이브와 리스토어 상태를 모니터링할 수
                  있습니다. 이보다 쉬운 아카이브 연동은 없습니다.
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>스마트 검색</h3>
                <span className={classes.contents}>
                  사용자는 수집된 영상 및 기타 미디어들을 손쉽게 검색할 수
                  있습니다. 특히 사용자의 업무 방식에 따라 설정 가능한 스마트
                  검색은 단 한번의 클릭으로 원하는 모든 것을 검색할 수 있습니다.
                  빈번하게 업무 내용이 바뀐다고 해도 몇 번의 클릭만으로 원하는
                  조합의 스마트 검색을 원하는 만큼 자유롭게 만들 수 있습니다.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1>COMPONENTS</h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      src="/img/digital-media/icon_64bit.png"
                      className={classes.icon}
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Server</h3>
                    <span className={classes.contents}>
                      KeyFlow Server는 업계 표준인 LP64 데이터 모델을 근거로
                      개발된 64비트 서버 소프트웨어로 대규모 데이터 처리에
                      탁월한 능력을 보여줍니다. 아울러 Open API 및 SDK for Mac,
                      Windows를 지원함으로써 사용자 요구에 따른 기능 확장을
                      손쉽게 할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_admin.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Manager</h3>
                    <span className={classes.contents}>
                      KeyFlow Manager는 사용자 중심적인 인터페이스와 강력하고
                      복잡한 구성을 매우 손쉽게 구성할 수 있게 해주는 관리자
                      전용 소프트웨어입니다. 원하는 기능을 추가하고 삭제하는
                      일은 물론 그룹 관리나 권한 부분까지 수정할 수 있는 강력한
                      기능을 지원합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_vcringest.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>HurryCapture for KeyFlow</h3>
                    <span className={classes.contents}>
                      HurryCapture for KeyFlow는 DV부터 XDCAM HD422까지 다양한
                      포맷의 인제스트를 지원하는 혁신적인 Tape 인제스트
                      솔루션입니다. 이미 국내 유수 방송국에서 많은 사용을 통해
                      기능을 검증받은 HurryCapture for KeyFlow는 Tape 인제스트
                      과정을 단순화시켜 드립니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_fileingest.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow File Ingest</h3>
                    <span className={classes.contents}>
                      KeyFlow File Ingest는 MOV 뿐만 아니라 P2 MXF(OP-Atom),
                      XDCAM MXF(OP1a)와 같은 Tapeless 포맷들을 지원하며 드래그앤
                      드롭으로 손쉽게 운영 관리할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_tunes.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Tunes</h3>
                    <span className={classes.contents}>
                      KeyFlow Tunes는 Mac과 Windows를 지원하는 사용자
                      클라이언트입니다. 사용자는 손쉽게 원하는 클립을 검색하고
                      드래그앤 드롭을 통한 NLE 연동 및 메타데이터 편집 등 편집
                      과정에 필요한 여러 가지 기능들을 매우 직관적으로 사용할 수
                      있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_exporter.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Exporter</h3>
                    <span className={classes.contents}>
                      KeyFlow Exporter는 Final Cut Pro 7, Final Cut Pro X ,
                      Premiere Pro CC, EDIUS와 같은 NLE 소프트웨어에서 단 한번의
                      클릭으로 편집 완본 및 편집본에 대한 MAM 등록을 할 수 있게
                      해주는 플러그인 입니다. NLE 프로그램 내에 플러그인
                      방식으로 탑재되어 사용자들은 간편하게 MAM 등록을 할 수
                      있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_quicktime.jpg"
                      with="65px"
                      height="70px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Compressor</h3>
                    <span className={classes.contents}>
                      KeyFlow compressor는 QuickTime 기반으로 SD부터 HD까지
                      다양한 포맷을 트랜스코딩을 할 수 있는 기능을 제공해주는
                      트랜스코더입니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_mxf.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow MXF</h3>
                    <span className={classes.contents}>
                      KeyFlow MXF는 현재 방송업무에서 필수 요소로 자리잡은 IMX
                      MXF 및 XDCAM HD422 MXF를 간단한 방법으로 만들며, MXF를
                      MOV로도 손쉽게 변환할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_informer.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Informer</h3>
                    <span className={classes.contents}>
                      KeyFlow Informer는 현존하는 대부분의 비디오, 오디오,
                      이미지 파일 등 방송 업무에서 필수적인 여러 가지 미디어
                      타입에 대한 정확하고 빠른 정보 추출 기능을 지원합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_archive.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Archiver</h3>
                    <span className={classes.contents}>
                      KeyFlow Archiver는 여러 아카이브 장비들과의 연동을 위한
                      최적의 솔루션 입니다. DIVA 및 기타 유수 아카이브 장비들과
                      유연하게 연결할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_delegator.png"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Delegator</h3>
                    <span className={classes.contents}>
                      KeyFlow Delegator는 시스템 통합 과정에서 전송되는 미디어
                      및 메타데이터가 각 시스템간에 서로 호환될 수 있게
                      처리해주는 기능을 지원합니다. 이를 통해 보다 안정적으로
                      시스템을 운영할 수 있습니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      src="/img/digital-media/icon_backup.jpeg"
                      with="65px"
                      height="70px"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Disk Backup</h3>
                    <span className={classes.contents}>
                      KeyFlow Disk Backup은 인제스트된 미디어들을 디스크에
                      백업하고 복구하는 기능을 제공하여 안정적으로 시스템을
                      운영할 수 있으며, 유사시 백업되어 있는 미디어를 사용할 수
                      있는 환경을 제공합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container>
                  <Grid item xs={12} sm={3}>
                    <img
                      className={classes.icon}
                      with="65px"
                      height="70px"
                      src="/img/digital-media/icon_archive.jpeg"
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <h3>KeyFlow Disk Archive</h3>
                    <span className={classes.contents}>
                      KeyFlow Disk Archive는 미디어를 디스크에 보관할 수 있는
                      아카이브 기능을 제공하며, 아카이브된 미디어를 쉽게
                      복원하여 사용할 수 있는 기능을 제공합니다.
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        className={classes.section2}
        style={{
          marginBottom: '200px',
        }}
      >
        <Container maxWidth="md">
          <div>
            <h1>WORKFLOW</h1>
            <div className={classes.hr} />
            <Grid container spacing={10}>
              <div
                style={{
                  marginTop: '30px',
                  paddingLeft: '10%',
                  paddingRight: '10%',
                }}
              >
                <img src="/img/digital-media/system-integration.png" />
              </div>
            </Grid>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
